import styled from 'styled-components';

export const TabsContainer = styled.div`
  flex-shrink: 0;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    ${({ theme }) => `padding: 0 ${theme.spacing.level4};`}
  }
`;
